import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import DTCItemContainer from '../containers/DTCItemContainer'
import { scrollToElement } from '../helpers/utils'
import { Flex } from 'antd'
import { useTerminology } from '../hooks/Terminology'
import { locale } from '../Locale'

const DTCList = ({ modules, sidebarOpen, makeModelId }) => {
  const dtcListRef = useRef(null)
  const [dtcCodes, setDtcCodes] = React.useState([])
  const { data: dtcTerms, isLoading: dtcTermsLoading } = useTerminology({
    makeModelId: makeModelId,
    language: locale,
    codes: dtcCodes,
  })
  useEffect(() => {
    if (sidebarOpen && dtcListRef.current) {
      const dtcList = dtcListRef.current
      const firstIndicatedDtc = dtcList.querySelector('.indicate')
      if (firstIndicatedDtc) {
        scrollToElement(dtcList.parentNode, firstIndicatedDtc)
      }
    }
  }, [sidebarOpen])

  useEffect(() => {
    const dtcCodesToFetch = []
    modules.forEach((module) => {
      const dtcs = module.dtcs || []
      dtcs.forEach((dtc) => {
        if (!dtc.translated_description && dtc.dtc_code) {
          dtcCodesToFetch.push(dtc.dtc_code)
        }
      })
    })
    if (dtcCodesToFetch.length > 0) {
      setDtcCodes([...new Set(dtcCodesToFetch)])
    }
  }, [modules])

  useEffect(() => {
    if (!dtcTerms || dtcTermsLoading) {
      return
    }
    modules.forEach((module, modIdx) => {
      const dtcs = module.dtcs || []
      dtcs.forEach((dtc, dtcIdx) => {
        if (dtc.dtc_code && dtcTerms[dtc.dtc_code]) {
          modules[modIdx].dtcs[dtcIdx].translated_description =
            dtcTerms[dtc.dtc_code].description
        }
      })
    })
  }, [dtcTerms, dtcTermsLoading])

  return (
    <Flex id="dtc-list" vertical={true} gap={1} ref={dtcListRef}>
      {!dtcTermsLoading &&
        modules.map((module) => (
          <DTCItemContainer key={module.acronym} module={module} />
        ))}
    </Flex>
  )
}

DTCList.propTypes = {
  modules: PropTypes.array.isRequired,
  sidebarOpen: PropTypes.bool,
}

export default DTCList
